export default __webpack_public_path__ + "static/media/astronaut_mini.b32ebd9f.jpg";